import styled from 'styled-components';

const SectionWrapper = styled.div`
  border-bottom: 1px solid #000;
  display: flex;
  margin-top: 25px;
  margin-bottom: 25px;
  padding-bottom: 25px;
`;

export default SectionWrapper;
